
import React, { useState, useEffect } from "react";
import { C, ROLES, apiFetch } from "../utils/api";
import FField from "./FField";

export default function Settings({cfg, onClose, loadCfg}) {
  const [tab,setTab]=useState("empresa");
  const [zonas,setZonas]=useState([]);
  const [editZona,setEditZona]=useState(null);
  const [zonaData,setZonaData]=useState({nombre:"",descripcion:"",lat:"",lng:"",zoom:"14"});
  const [zonaErr,setZonaErr]=useState("");
  const [savingZona,setSavingZona]=useState(false);
  const [nombre,setNombre]=useState(cfg.nombre_empresa||"");

  const [saving,setSaving]=useState(false);
  const [usuarios,setUsuarios]=useState([]);
  const [loadingU,setLoadingU]=useState(false);
  const [showForm,setShowForm]=useState(false);
  const [editUser,setEditUser]=useState(null);
  const [uData,setUData]=useState({nombre:"",username:"",password:"",rol:"tecnico",activo:1});
  const [uErr,setUErr]=useState("");

  useEffect(()=>{ if(tab==="usuarios") loadUsuarios(); if(tab==="zonas") loadZonas(); },[tab]);
  const loadZonas=async()=>{ const d=await apiFetch("/proyectos.php"); if(d.success) setZonas(d.proyectos); };
  const openEditZona=(z)=>{ setEditZona(z); setZonaData({nombre:z.nombre,descripcion:z.descripcion||'',lat:z.lat,lng:z.lng,zoom:z.zoom||14}); setZonaErr(""); };
  const submitZona=async()=>{
    setSavingZona(true); setZonaErr("");
    const d=await apiFetch("/proyectos.php",{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({...zonaData,id:editZona.id})});
    setSavingZona(false);
    if(d.success){setEditZona(null);loadZonas();} else setZonaErr(d.error||"Error al guardar");
  };

  const loadUsuarios=async()=>{ setLoadingU(true); const d=await apiFetch("/usuarios.php"); if(d.success) setUsuarios(d.usuarios); setLoadingU(false); };

  const submitEmpresa=async()=>{
    setSaving(true);
    await apiFetch("/configuracion.php",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({nombre_empresa:nombre})});
    setSaving(false); await loadCfg(); onClose();
  };

  const openCreate=()=>{ setEditUser(null); setUData({nombre:"",username:"",password:"",rol:"tecnico",activo:1}); setUErr(""); setShowForm(true); };
  const openEdit=(u)=>{ setEditUser(u); setUData({nombre:u.nombre,username:u.username,password:"",rol:u.rol,activo:parseInt(u.activo)}); setUErr(""); setShowForm(true); };

  const submitUser=async()=>{
    setUErr("");
    if(!uData.nombre||!uData.username||(!editUser&&!uData.password)){setUErr("Completa los campos requeridos");return;}
    const method=editUser?"PUT":"POST";
    const body=editUser?{...uData,id:editUser.id}:uData;
    const d=await apiFetch("/usuarios.php",{method,headers:{"Content-Type":"application/json"},body:JSON.stringify(body)});
    if(d.success){setShowForm(false);loadUsuarios();}
    else setUErr(d.error||"Error al guardar");
  };

  const deleteUser=async(id)=>{
    if(!window.confirm("Eliminar usuario?")) return;
    await apiFetch("/usuarios.php",{method:"DELETE",headers:{"Content-Type":"application/json"},body:JSON.stringify({id})});
    loadUsuarios();
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"flex-end",zIndex:200}}>
      <div style={{background:"#FFFFFF",borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,margin:"0 auto",padding:"1.5rem",maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{width:40,height:4,background:"#E8ECF0",borderRadius:99,margin:"0 auto 16px"}}/>
        <p style={{margin:"0 0 16px",fontWeight:600,fontSize:16}}>Configuracion</p>
        <div style={{display:"flex",gap:6,marginBottom:20,overflowX:"auto"}}>
          {[["empresa","Empresa"],["usuarios","Usuarios"],["zonas","Zonas"]].map(([t,l])=>(
            <div key={t} onClick={()=>setTab(t)} style={{flexShrink:0,flex:1,textAlign:"center",padding:"8px 0",borderRadius:8,fontSize:13,fontWeight:500,cursor:"pointer",background:tab===t?"#1E7BBF":"#F5F7FA",color:tab===t?"#fff":"#6B7280"}}>
              {l}
            </div>
          ))}
        </div>
        {tab==="empresa"&&(
          <div>
            <label style={{fontSize:13,color:"#6B7280"}}>Nombre de la empresa</label>
            <input value={nombre} onChange={e=>setNombre(e.target.value)} style={{display:"block",width:"100%",padding:"10px 12px",borderRadius:8,border:"1px solid #E8ECF0",fontSize:14,marginTop:4,marginBottom:14,boxSizing:"border-box"}}/>

            <div style={{display:"flex",gap:8}}>
              <button onClick={submitEmpresa} disabled={saving} style={{flex:1,padding:"12px 0",background:"#1E7BBF",color:"#fff",border:"none",borderRadius:10,fontSize:14,fontWeight:600,cursor:"pointer"}}>{saving?"Guardando...":"Guardar"}</button>
              <button onClick={onClose} style={{flex:1,padding:"12px 0",background:"#F5F7FA",color:"#2C2C2C",border:"1px solid #E8ECF0",borderRadius:10,fontSize:14,cursor:"pointer"}}>Cancelar</button>
            </div>
          </div>
        )}
        {tab==="usuarios"&&!showForm&&(
          <div>
            <button onClick={openCreate} style={{width:"100%",padding:"10px 0",background:"#1E7BBF",color:"#fff",border:"none",borderRadius:8,fontSize:14,fontWeight:600,cursor:"pointer",marginBottom:14}}>+ Crear usuario</button>
            {loadingU&&<p style={{textAlign:"center",color:"#6B7280",fontSize:13}}>Cargando...</p>}
            {usuarios.map(u=>(
              <div key={u.id} style={{background:"#F5F7FA",borderRadius:10,padding:"12px",marginBottom:8,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <p style={{margin:0,fontSize:13,fontWeight:600}}>{u.nombre}</p>
                  <p style={{margin:0,fontSize:12,color:"#6B7280"}}>@{u.username} - {ROLES[u.rol]}</p>
                  <p style={{margin:0,fontSize:11,color:parseInt(u.activo)?"#16A34A":"#DC2626"}}>{parseInt(u.activo)?"Activo":"Inactivo"}</p>
                </div>
                <div style={{display:"flex",gap:6}}>
                  <button onClick={()=>openEdit(u)} style={{padding:"6px 10px",background:"#1E7BBF",color:"#fff",border:"none",borderRadius:6,fontSize:12,cursor:"pointer"}}>Editar</button>
                  <button onClick={()=>deleteUser(u.id)} style={{padding:"6px 10px",background:"#FEE2E2",color:"#991B1B",border:"none",borderRadius:6,fontSize:12,cursor:"pointer"}}>X</button>
                </div>
              </div>
            ))}
            <button onClick={onClose} style={{width:"100%",marginTop:8,padding:"10px 0",background:"#F5F7FA",color:"#2C2C2C",border:"1px solid #E8ECF0",borderRadius:10,fontSize:14,cursor:"pointer"}}>Cerrar</button>
          </div>
        )}
        {tab==="zonas"&&(
          <div>
            {!editZona ? (
              <div>
                {zonas.map(z=>(
                  <div key={z.id} style={{background:"#F5F7FA",borderRadius:10,padding:"12px",marginBottom:8,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    <div>
                      <p style={{margin:0,fontSize:13,fontWeight:600}}>{z.nombre}</p>
                      <p style={{margin:0,fontSize:12,color:"#6B7280"}}>{z.descripcion||"Sin descripcion"}</p>
                      <p style={{margin:0,fontSize:11,color:"#6B7280"}}>Centro: {parseFloat(z.lat).toFixed(4)}, {parseFloat(z.lng).toFixed(4)} | Zoom: {z.zoom}</p>
                    </div>
                    <button onClick={()=>openEditZona(z)} style={{padding:"6px 10px",background:"#1E7BBF",color:"#fff",border:"none",borderRadius:6,fontSize:12,cursor:"pointer"}}>Editar</button>
                  </div>
                ))}
                <button onClick={onClose} style={{width:"100%",marginTop:8,padding:"10px 0",background:"#F5F7FA",color:"#2C2C2C",border:"1px solid #E8ECF0",borderRadius:10,fontSize:14,cursor:"pointer"}}>Cerrar</button>
              </div>
            ):(
              <div>
                <p style={{margin:"0 0 14px",fontWeight:600,fontSize:14}}>Editar zona: {editZona.nombre}</p>
                {[["nombre","Nombre"],["descripcion","Descripcion"],["lat","Latitud centro"],["lng","Longitud centro"],["zoom","Zoom (1-20)"]].map(([k,l])=>(
                  <div key={k} style={{marginBottom:10}}>
                    <label style={{fontSize:13,color:"#6B7280",display:"block",marginBottom:3}}>{l}</label>
                    <input value={zonaData[k]} onChange={e=>setZonaData(d=>({...d,[k]:e.target.value}))}
                      style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid #E8ECF0",fontSize:14,boxSizing:"border-box"}}/>
                  </div>
                ))}
                {zonaErr&&<p style={{color:"#E53E3E",fontSize:13,margin:"0 0 10px"}}>{zonaErr}</p>}
                <div style={{display:"flex",gap:8}}>
                  <button onClick={submitZona} disabled={savingZona} style={{flex:1,padding:"10px 0",background:"#1E7BBF",color:"#fff",border:"none",borderRadius:8,fontSize:14,fontWeight:600,cursor:"pointer"}}>{savingZona?"Guardando...":"Guardar"}</button>
                  <button onClick={()=>setEditZona(null)} style={{flex:1,padding:"10px 0",background:"#F5F7FA",color:"#2C2C2C",border:"1px solid #E8ECF0",borderRadius:8,fontSize:14,cursor:"pointer"}}>Cancelar</button>
                </div>
              </div>
            )}
          </div>
        )}
        {tab==="usuarios"&&showForm&&(
          <div>
            <p style={{margin:"0 0 14px",fontWeight:600,fontSize:14}}>{editUser?"Editar usuario":"Crear usuario"}</p>
            <FField k="nombre" label="Nombre completo *" val={uData.nombre} onChange={(k,v)=>setUData(x=>({...x,[k]:v}))}/>
            <FField k="username" label="Usuario *" val={uData.username} onChange={(k,v)=>setUData(x=>({...x,[k]:v}))}/>
            <FField k="password" label={editUser?"Nueva contrasena (opcional)":"Contrasena *"} type="password" val={uData.password} onChange={(k,v)=>setUData(x=>({...x,[k]:v}))}/>
            <FField k="rol" label="Rol" val={uData.rol} onChange={(k,v)=>setUData(x=>({...x,[k]:v}))} opts={Object.entries(ROLES).map(([k,v])=>({v:k,l:v}))}/>
            <div style={{marginBottom:14,display:"flex",alignItems:"center",gap:8}}>
              <input type="checkbox" checked={uData.activo===1} onChange={e=>setUData(x=>({...x,activo:e.target.checked?1:0}))} id="activo"/>
              <label htmlFor="activo" style={{fontSize:13,cursor:"pointer"}}>Usuario activo</label>
            </div>
            {uErr&&<p style={{color:"#E53E3E",fontSize:13,margin:"0 0 10px"}}>{uErr}</p>}
            <div style={{display:"flex",gap:8}}>
              <button onClick={submitUser} style={{flex:1,padding:"10px 0",background:"#1E7BBF",color:"#fff",border:"none",borderRadius:8,fontSize:14,fontWeight:600,cursor:"pointer"}}>{editUser?"Guardar cambios":"Crear"}</button>
              <button onClick={()=>setShowForm(false)} style={{flex:1,padding:"10px 0",background:"#F5F7FA",color:"#2C2C2C",border:"1px solid #E8ECF0",borderRadius:8,fontSize:14,cursor:"pointer"}}>Cancelar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
